import React from 'react'
import AnalyticsLineChart from '../analytics/charts/AnalyticsLineChart'

export type ErpLineSeries = {
 name?: string
 data: number[]
 color?: string
 area?: boolean
}

export type ErpLineChartProps = {
 categories: string[]
 series: ErpLineSeries[]
 height?: number
 showLegend?: boolean
 valueFormatter?: (value: number) => string
 className?: string
}

/** @deprecated Use AnalyticsLineChart instead. */
const ErpLineChart: React.FC<ErpLineChartProps> = ({
 categories,
 series,
 height = 300,
 showLegend = false,
 valueFormatter,
 className,
}) => {
 return (
  <AnalyticsLineChart
   categories={categories}
   series={series.map((item) => ({
    name: item.name ?? '',
    data: item.data,
    color: item.color,
    showArea: item.area,
   }))}
   height={height}
   showLegend={showLegend}
   valueFormatter={valueFormatter}
   className={className}
  />
 )
}

export default ErpLineChart
